<!--
  Author: Gary Hammock
  Version: 0.1.0
  Description: The initial page/view.
-->

<template>
  <article
    class="home"
    aria-label="welcome"
  >
    <b-jumbotron
      header="Welcome"
    >
      <template v-slot:lead>
        Hello!  Thanks for visiting.  I'm Gary Hammock.
      </template>
    </b-jumbotron>
    <h1 class="border-bottom">
      About Me
    </h1>
    <p>
      I'm a father of two amazing kids, a husband of an awesome wife,
      a software engineer, a mechanical engineer, a gamer, puzzle-nerd, and probably a thousand other things.
      <small>
        Maybe one day I'll get around to finishing all those other things.
      </small>
    </p>
    <p class="text-center my-4">
      <b-img-lazy
        fluid
        alt="a photo of me"
        title="A Photo of Me"
        src="/assets/img/media/me.jpg"
        class="rounded-lg mx-auto shadow"
      />
    </p>
    <p>
      Some of my hobbies are (in no particular order):
      <ul>
        <li>Video Games</li>
        <li>Music</li>
        <li>Digital Photography</li>
        <li>Cryptography</li>
        <li>Puzzles</li>
      </ul>
    </p>
    <p>
      I'll try to keep things on my site updated.  I've got plans to implement an entire Node-based
      <abbr title="Content Management System">CMS</abbr> here.  Life and work tend to get in the way a lot,
      but I'll do my best.
    </p>
  </article>
</template>

<script>
export default {
  name: 'Home'
}
</script>
